export default function isServer() {
  return typeof window === 'undefined';
}



// WEBPACK FOOTER //
// ./src/utils/isServer.js